export var CREATE_PARTNER_REQUEST = 'CREATE_PARTNER_REQUEST';
export var CREATE_PARTNER_SUCCEEDED = 'CREATE_PARTNER_SUCCEEDED';
export var CREATE_PARTNER_FAILED = 'CREATE_PARTNER_FAILED';
export var FETCH_PARTNERS_REQUEST = 'FETCH_PARTNER_REQUEST';
export var FETCH_PARTNERS_SUCCEEDED = 'FETCH_PARTNERS_SUCCEEDED';
export var FETCH_PARTNERS_FAILED = 'FETCH_PARTNERS_FAILED';
export var DELETE_PARTNER_REQUEST = 'DELETE_PARTNER_REQUEST';
export var DELETE_PARTNER_SUCCEEDED = 'DELETE_PARTNER_SUCCEEDED';
export var DELETE_PARTNER_FAILED = 'DELETE_PARTNER_FAILED';
export var UPDATE_PARTNER_REQUEST = 'UPDATE_PARTNER_REQUEST';
export var UPDATE_PARTNER_FAILED = 'UPDATE_PARTNER_FAILED';
export var UPDATE_PARTNER_SUCCEEDED = 'UPDATE_PARTNER_SUCCEEDED';
export var SEND_INVITATION_REQUEST = 'SEND_INVITATION_REQUEST';
export var SEND_INVITATION_FAILED = 'SEND_INVITATION_FAILED';
export var SEND_INVITATION_SUCCEEDED = 'SEND_INVITATION_SUCCEEDED';
